import {
  Injectable,
  inject,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
  UrlTree,
} from '@angular/router';
import {JwtService} from '../../services/infrastructure/auth/jwt/jwt.service';
import {Constants} from '../../common/constants/constants';

@Injectable({
  providedIn: 'root',
})
export class GuardService {

  private jwtService = inject(JwtService);

  private activatedRoute = inject(ActivatedRoute);

  private router = inject(Router);

  /**
   * Method: Guard redirect
   */
  async guardRedirect(): Promise<void> {
    const hasToken = this.jwtService.hasAccessToken();
    if (hasToken) {
      await this.router.navigate(['/error/access-denied']);
    } else {
      await this.router.navigate([Constants.SLASH], {relativeTo: this.activatedRoute});
    }
  }

  /**
   * Method: Create the url tree a guard returns when it denies access
   */
  createRedirectUrlTree(): UrlTree {
    return this.jwtService.hasAccessToken()
      ? this.router.createUrlTree(['/error/access-denied'])
      : this.router.createUrlTree([Constants.SLASH], {relativeTo: this.activatedRoute});
  }

}
